"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "zh-cn": {
        "languageCode": "zh-cn"
    },
    "en-us": {
        "languageCode": "en-us"
    }
};
//# sourceMappingURL=locale.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/locale.js
// module id = 582
// module chunks = 0